export const errorCodes = {
  DEAL_NOT_FOUND: 'ERROR_DEAL_NOT_FOUND',
  NOT_FOUND: 404,
};
